import React, { useState, useEffect, useRef } from "react";
import InvoiceReceiptSeriesController from "../../../../Controllers/AdminScreens/Invoices/Settings/InvoiceReceiptSeriesController";
import editImg from "../../../../../Assets/Icons/edit.png";
import deleteImg from "../../../../../Assets/Icons/delete.png";
import Loader from "../../../../../Components/Loader";
import DeleteConfirmationModal from "../../../../../Components/Modals/DeleteConformationModal";
import { convertGMTToLocal } from "../../../../../Utils/Validation";

const InvoiceReceiptSeriesScreen = ({ seriesHistory, loading, error, toggleReceiptSeries, toggleUpdateReceiptSeries, onRefresh }) => {
    const {
        deleteLoading,
        deleteError,
        deleteSuccess,
        handleEdit,
        handleDeleteServiceType,
        callDeleteServiceType,
        isDeleteModalOpen,
        selectedReceipt,
        handleCloseDeleteModal,
    } = InvoiceReceiptSeriesController(onRefresh,toggleReceiptSeries);

    const getSeriesTypeLabel = (seriesType) => {
        switch (seriesType) {
            case 1: return "Manual";
            case 2: return "Automatic";
            case 3: return "Prefix";
            default: return "Unknown";
        }
    };

    return (
        <div>
            {/* Title */}
            <div className="tasksScreen-tasks-header" style={{ paddingBottom: 10 }}>
                <h3 className="tasksScreen-tasks-title">History</h3>
            </div>

            {/* Table */}
            <div className="tasksScreen-task-table-wrapper">
                <table className="tasksScreen-task-table">
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>Series Type</th>
                            <th style={{ width: "20%" }}>Start Date</th>
                            <th style={{ width: "20%" }}>End Date</th>
                            <th style={{ width: "30%" }}>Added By</th>
                            {/* <th onClick={toggleReceiptSeries}>+   Add</th> */}
                        </tr>
                    </thead>
                    {seriesHistory.length > 0 && (
                        <tbody style={{ backgroundColor: "white" }}>
                            {seriesHistory.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ textDecoration: 'underline' }}>
                                        {item?.series_type === 1 ? "Manual" :
                                            item?.series_type === 2 ? "Automatic" :
                                                item?.series_type === 3 ? "Prefix" :
                                                    "--"}{" "} <span >{item?.series_type === 3 && item?.series_prefix ? ` (${item?.series_prefix})` : ""}</span>
                                    </td>
                                  <td>{item?.series_start_at ? convertGMTToLocal(item?.series_start_at,'dd/MM/yyyy') : '--'}</td>
                                    <td>{item?.series_end_at ? convertGMTToLocal(item?.series_end_at,'dd/MM/yyyy') : '--'}</td>
                                    <td>{item?.create_by_name || "--"}
                                        {deleteSuccess[item?.series_id] &&
                                            <div style={{ color: 'green', textDecoration: 'none', paddingTop: 10 }} >{deleteSuccess[item?.series_id]}</div>}
                                        {deleteError[item?.series_id] &&
                                            <div className="list-error-msg" style={{ paddingTop: 10 }} >{deleteError[item?.series_id]}</div>}
                                    </td>
                                    <td style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                                        <button className="tasksScreen-edit-button" onClick={() => toggleUpdateReceiptSeries(item)}>
                                            <img src={editImg} alt="Edit" style={{ height: '16px', width: '16px'}} />
                                        </button>
                                        <button className="tasksScreen-delete-button"
                                            style={{
                                                border: "none",
                                                background: "transparent",
                                                cursor: "pointer",
                                                opacity: deleteLoading[item?.series_id] ? 0.3 : 1
                                            }}
                                            onClick={() => { handleDeleteServiceType(item) }}
                                            disabled={deleteLoading[item?.series_id]}>
                                            <img src={deleteImg} alt="Delete" style={{ height: '16px', width: '16px'}} />
                                        </button>
                                        {deleteLoading[item?.series_id] &&
                                            <span><Loader loading={deleteLoading[item?.series_id]} color={'var(--primary-loader-color)'} size='small' /></span>
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>

                {/* Loader & Error Message */}
                {loading && <Loader loading={loading} color="var(--primary-loader-color)" />}
                {error && <div className="list-error-msg">{error} </div>}
                <DeleteConfirmationModal
                    isOpen={isDeleteModalOpen}
                    message={`Are you sure you want to delete ${getSeriesTypeLabel(selectedReceipt?.series_type)}?`}
                    onClose={handleCloseDeleteModal}
                    onConfirm={() => {
                        handleCloseDeleteModal(); // Close modal
                        callDeleteServiceType(selectedReceipt); // Perform delete operation
                    }}
                />
            </div>
        </div>
    );
};

export default InvoiceReceiptSeriesScreen;
